import type { IconSvgObject } from './types';

const BendToolIcon: IconSvgObject = [
  ["circle", { cx: "19", cy: "4", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "5", cy: "20", r: "2", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M5 18C5 10 10 4 17 4", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BendToolIcon;
